<div class="info-strip-left">
  <button class="back-button" type="button" (click)="back('/rec-plan-bp-result-pg')">
    <i class="fa fa-caret-left"></i> <p>Back</p>
  </button>
</div>
<app-rec-plan-doc-image [book]="book" [page]="page" [bookType]="bookType" (changeImgVwVisible)="getIsImgVwVisible($event)"></app-rec-plan-doc-image>
